const REGISTRATION_STATES = new Set(["open", "not_open", "closed", "full"]);
const REGISTRATION_LIFECYCLE_STATUSES = new Set(["published", "registration_open", "registration_closed"]);

export function getRegistrationAvailability(competition = {}) {
  const source = competition?.registrationAvailability;
  const state = REGISTRATION_STATES.has(source?.state) ? source.state : "unavailable";
  const capacitySource = source?.capacity || {};
  const max = Number.isFinite(Number(capacitySource.max)) && capacitySource.max !== null
    ? Number(capacitySource.max)
    : null;
  const used = Number.isFinite(Number(capacitySource.used))
    ? Math.max(0, Number(capacitySource.used))
    : 0;

  return {
    state,
    canRegister: state === "open" && source?.canRegister === true,
    reason: source?.reason || (state === "unavailable" ? "Disponibilidad de inscripción no confirmada." : null),
    capacity: {
      used,
      max,
      isFull: source?.capacity?.isFull === true,
    },
  };
}

export function isRegistrationAvailable(competition = {}) {
  return getRegistrationAvailability(competition).canRegister;
}

export function getRegistrationPresentation(competition = {}) {
  const availability = getRegistrationAvailability(competition);
  const lifecycleStatus = String(competition?.statusKey || competition?.status || "").toLowerCase();

  if (availability.canRegister) {
    return {
      applies: true,
      statusKey: "registration_open",
      statusLabel: "Inscripción abierta",
      ctaLabel: "Inscribirme",
      ctaTone: "primary",
      availability,
    };
  }

  if (availability.state === "not_open") {
    return {
      applies: true,
      statusKey: "registration_not_open",
      statusLabel: "Inscripciones próximas",
      ctaLabel: "Ver evento",
      ctaTone: "outline",
      availability,
    };
  }

  if (availability.state === "full") {
    return {
      applies: true,
      statusKey: "registration_full",
      statusLabel: "Cupos completos",
      ctaLabel: "Ver evento",
      ctaTone: "outline",
      availability,
    };
  }

  if (availability.state === "closed" && REGISTRATION_LIFECYCLE_STATUSES.has(lifecycleStatus)) {
    return {
      applies: true,
      statusKey: "registration_closed",
      statusLabel: "Inscripción cerrada",
      ctaLabel: "Ver evento",
      ctaTone: "outline",
      availability,
    };
  }

  if (availability.state === "unavailable" && lifecycleStatus === "registration_open") {
    return {
      applies: true,
      statusKey: "registration_unavailable",
      statusLabel: "Disponibilidad no confirmada",
      ctaLabel: "Ver evento",
      ctaTone: "outline",
      availability,
    };
  }

  return {
    applies: false,
    statusKey: lifecycleStatus,
    statusLabel: "",
    ctaLabel: "Ver evento",
    ctaTone: "outline",
    availability,
  };
}
